import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { reportingCountryWiseAPI } from "../../../api/reporting/reportingApiHelper"
import Notify from "components/Common/notify"

export const CountryWiseReportFetch = createAsyncThunk(
  "Reporting/CountryWiseReportFetch",
  async data => {
    try {
      const response = await reportingCountryWiseAPI(data)
      const _response = {
        data: response?.data,
        status: response?.status,
      }
      return _response
    } catch (error) {
      Notify("error", "Failed to fetch Country-wise Report")
      throw Error("Failed to fetch Country-wise Report")
    }
  },
)

const initialState = {
  countryWiseData: [],
  loading: false,
  error: null,
}

export const ReportingSlice = createSlice({
  name: "ReportingSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(CountryWiseReportFetch.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(CountryWiseReportFetch.fulfilled, (state, action) => {
        state.loading = false
        // Response may be a plain array, or wrapped as { data: [...] } / { items: { data: [...] } }
        const respData = action.payload?.data
        const container = respData?.items || respData || {}
        const items = Array.isArray(respData)
          ? respData
          : container?.data || container?.items || []
        state.countryWiseData = Array.isArray(items) ? items : []
      })
      .addCase(CountryWiseReportFetch.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  },
})

export const {} = ReportingSlice.actions

export const allReporting = state => state.allReporting

export default ReportingSlice.reducer
